import React from 'react';
import { tokens } from '@domain-group/fe-brary';
import { Star } from '../star';
import * as styles from './index.styles';

const { colors } = tokens;

type StarRatingProps = {
  fillBackground?: string;
  fillStar?: string;
  rating: number;
  maxRating?: number;
  starSize?: number;
  starGap?: number;
  strokeColor?: string;
  strokeWidth?: number;
};

export function StarRating({
  fillBackground = 'none',
  fillStar = colors.warning.base.default,
  rating,
  maxRating = 5,
  starSize = 20,
  starGap = 1,
  strokeColor = colors.warning.base.default,
  strokeWidth = 5,
}: StarRatingProps): JSX.Element {
  const getRatingPercents = () => {
    // Ensure the rating is within the range of 0 to maxRating
    const adjustedFinalRating = Math.min(maxRating, Math.max(rating, 0));

    // Calculate the number of full stars and the fractional part
    const totalFullStars = Math.floor(adjustedFinalRating);
    const starFraction =
      adjustedFinalRating % 1 === 0 ? 0 : (adjustedFinalRating % 1) * 100;

    // - Fill the spots for the full stars with 100%
    // - Fill the fractional star with the calculated percentage
    // - Fill the remaining spots with 0%
    // - Limit the total number of spots to maxRating
    return [
      ...Array(totalFullStars).fill(100),
      starFraction,
      ...Array(maxRating).fill(0),
    ].slice(0, maxRating);
  };

  return (
    <div css={styles.starRating(starGap)}>
      {getRatingPercents().map((percentage) => (
        <span css={styles.starWrapper} key={`${Math.random()}`}>
          <Star
            fillBackground={fillBackground}
            percentage={percentage}
            fillStar={fillStar}
            size={starSize}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </span>
      ))}
    </div>
  );
}

export default StarRating;
